/**
 * Logic Necessary for the CPE
 * List View
 * Author: Imarc 2019
 */

import classToggle from '@inkwell/scripts/modules/classtoggle';
import convertToLocalTime from '@inkwell/scripts/modules/datetimeHandler';


const options = document.querySelector('[data-options-details]');
const resultsFiltersForm = document.querySelector('#results-filters');
const keywordFilter = resultsFiltersForm.querySelector('[name="f[kw]"]');
const keywordMinimumLength = Number.parseInt(
    resultsFiltersForm.dataset.keywordMinimumLength,
    10
);

classToggle({
    elementClass: '.js-group',
    triggerClass: '.js-groupTrigger',
    toggleClass: '-open',
});

const addClearListeners = () => {
    const appliedFiltersElement = document.querySelector('#applied-filters');
    const clearButtons = [...appliedFiltersElement.querySelectorAll('[data-clear]')];

    clearButtons.forEach(button => {
        button.addEventListener(
            'click',
            function applyEventListener(event) {
                event.preventDefault();
                let formElement = resultsFiltersForm.querySelector(
                    `[name="${button.name}"]:not([type="hidden"])`
                );

                if (!formElement) {
                    formElement = resultsFiltersForm.querySelector(
                        `[data-name="${button.name}"]`
                    );
                }

                if ('slimselect' in formElement.dataset) {
                    const option = formElement.querySelector(
                        `option[value="${button.value}"]`
                    );
                    const selectedValues = formElement.slimSelect.selected();
                    const filteredValues = selectedValues.filter(
                        value => value !== button.value
                    );
                    formElement.slimSelect.set(filteredValues);
                    option.removeAttribute('selected');
                    button.remove();
                    resultsFiltersForm.dispatchEvent(new Event('change'));
                    return;
                }

                if ('flatpickr' in formElement.dataset) {
                    const inputWrapper = formElement.closest('.js-dateRange');
                    const dateBefore = inputWrapper.querySelector('.js-dateBefore');
                    const dateAfter = inputWrapper.querySelector('.js-dateAfter');
                    dateBefore.value = null;
                    dateAfter.value = null;
                    formElement.flatpickr.clear();
                    button.remove();
                    resultsFiltersForm.dispatchEvent(new Event('change'));
                    return;
                }

                if (formElement.type === 'checkbox') {
                    const associatedCheckbox = resultsFiltersForm.querySelector(
                        `input[name="${button.name}"][value="${button.value}"]`
                    );
                    associatedCheckbox.checked = false;
                    associatedCheckbox.removeAttribute('checked');
                    button.remove();
                    resultsFiltersForm.dispatchEvent(new Event('change'));
                    return;
                }

                formElement.value = null;

                button.remove();
                resultsFiltersForm.dispatchEvent(new Event('change'));
            },
            false
        );
    });
};

const applyFilterCounts = filterCounts => {
    Object.entries(filterCounts).forEach(([name, filterData]) => {
        const selectElement = document.querySelector(`select[name^="f[${name}]"]`);
        const checkboxes = [...document.querySelectorAll(`[name="f[${name}][]"]`)];

        if (selectElement) {

            if (typeof selectElement.slimSelect != 'undefined') {
                const selected        = selectElement.slimSelect.selected();
                const selectedOptions = [...selectElement.querySelectorAll('option')].filter((option) => {
                    return selected.includes(option.value);
                });

                selectedOptions.forEach(option => {
                    if (!filterData.data.some(item => item.value == option.value)) {
                        filterData.data.push({
                            label: option.innerHTML.replace(/\s+<strong>.*<\/strong>$/, ''),
                            value: option.value,
                            subtotal: 0
                        });
                    }
                });

                selectElement.slimSelect.setData(
                    filterData.data.map(countDataObject => {
                        return {
                            text: `${countDataObject.label} <strong>(${countDataObject.subtotal})</strong>`,
                            value: countDataObject.value,
                            count: countDataObject.subtotal,
                            selected: selected.includes(countDataObject.value),
                            data: {
                                originalName: countDataObject.label
                            }
                        };
                    })
                )
            }

        } else if (checkboxes.length) {
            checkboxes.forEach(checkboxElement => {
                if (typeof filterData.data !== 'undefined') {
                    const associatedCountDataObject = filterData.data.find(
                        ({ value }) => value === checkboxElement.value
                    );

                    const label = checkboxElement.closest('label');

                    if (label) {
                        label.style.display = 'block';
                        const textSpan = label.querySelector('span');

                        if (!('originalText' in label.dataset)) {
                            label.dataset.originalText = textSpan.textContent;
                        }

                        const labelElement = label.querySelector('span');
                        if (typeof associatedCountDataObject !== 'undefined') {
                            labelElement.innerHTML = `${label.dataset.originalText} <strong>(${associatedCountDataObject.subtotal})</strong>`;    
                        } else if (checkboxElement.checked) {
                            labelElement.innerHTML = `${label.dataset.originalText} <strong>(0)</strong>`;
                        } else {
                            label.style.display = 'none';
                        }
                    }
                }
            });
        }
    });
};

addClearListeners();
applyFilterCounts(window.filterCounts);

const addToggleToListItems = () => {
    document.querySelectorAll('[data-cpe-list-item]').forEach(item => {
        item.addEventListener('click', event => {
            event.currentTarget.classList.toggle('-expanded');
        });
    });
};


const applyDateTime = () => {
    document.querySelectorAll('[data-cpe-list-item]').forEach(item => {
        const timeElements = item.querySelectorAll('time');
        timeElements.forEach(convertToLocalTime);
    });
};


addToggleToListItems();

if (options) {
    classToggle({
        elementClass: '[data-options-details]',
        triggerClass: '[data-options-toggle]',
        toggleClass: '-expanded',
    });
}

document.body.addEventListener('htmx:load', ({ detail }) => {
    if (detail.elt.id === 'applied-filters') {
        addClearListeners();
        applyFilterCounts(window.filterCounts);
    }

    if (detail.elt.id === 'results') {
        addToggleToListItems();
        applyDateTime();
    }

    if (detail.elt.id === 'groups') {
        classToggle({
            elementClass: '.js-group',
            triggerClass: '.js-groupTrigger',
            toggleClass: '-open',
        });
    }
});

const hasIncompleteKeyword = target => {
    if (target !== keywordFilter) {
        return false;
    }

    const value = target.value.trim().replace(/\s+/g, ' ');

    return value.length > 0 && value.length < keywordMinimumLength;
};

document.body.addEventListener('htmx:beforeRequest', event => {
    const target = event.detail.requestConfig.triggeringEvent.explicitOriginalTarget;

    if (
        hasIncompleteKeyword(target) ||
        target.hasAttribute('data-clear')
    ) {
        event.preventDefault();
    }
});

const catalogMessages = {
    generating: 'Generating your PDF. This can take a minute.',
    complete: 'Your PDF has downloaded.',
    failed: 'We could not generate your PDF. Please wait a few minutes and try again.',
    limited: "You've downloaded several catalogs in the last few minutes. Please wait a few minutes before downloading another.",
};

const getCatalogFilename = response => {
    const disposition = response.headers.get('Content-Disposition') || '';
    const match = disposition.match(/filename="?([^";]+)"?/);

    return match ? match[1] : 'cpe-catalog.pdf';
};

// Download the catalog without leaving the page, so the button can show progress. Capturing
// on the document runs before Inkwell's POST form handler, which would lock the form after
// one submission.
document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-catalog-download]');

    if (!form) {
        return;
    }

    event.preventDefault();
    event.stopPropagation();

    const button = form.querySelector('[type="submit"]');
    const status = form.querySelector('[data-catalog-status]');

    if (button.classList.contains('-processing')) {
        return;
    }

    button.classList.add('-processing');
    button.disabled = true;
    status.textContent = catalogMessages.generating;

    try {
        const response = await fetch(form.action, {
            method: 'POST',
            body: new FormData(form),
            credentials: 'same-origin',
            headers: { Accept: 'application/pdf' },
        });

        if (response.status === 429) {
            status.textContent = catalogMessages.limited;
            return;
        }

        if (!response.ok || !response.headers.get('Content-Type')?.includes('application/pdf')) {
            throw new Error('The catalog PDF was not generated');
        }

        const link = document.createElement('a');
        link.href = URL.createObjectURL(await response.blob());
        link.download = getCatalogFilename(response);
        link.click();
        setTimeout(() => URL.revokeObjectURL(link.href), 1000);

        status.textContent = catalogMessages.complete;
    } catch (error) {
        status.textContent = catalogMessages.failed;
    } finally {
        button.classList.remove('-processing');
        button.disabled = false;
    }
}, true);
